import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import VehicleFeatures from './VehicleFeatures';
import PriceDisplay from './PriceDisplay';
import InfoBadge from './InfoBadge';
import { analytics } from '../services/analytics';
import { useBooking } from '../context/BookingContext';
import { toast } from '../utils/toast';
import './VehicleCard.css';

const VehicleCard = ({ vehicle }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { updateSelectedVehicle } = useBooking();

  useEffect(() => {
    analytics.trackVehicleView(vehicle);
  }, [vehicle]);

  const handleConsult = () => {
    analytics.trackVehicleConsult(vehicle);
    updateSelectedVehicle(vehicle);
    
    // Preservar los parámetros de búsqueda
    const params = new URLSearchParams(searchParams);
    navigate(`/reserva?${params.toString()}`, { state: { vehicle } });
  };

  const handleShare = async () => {
    const params = new URLSearchParams(searchParams);
    const shareUrl = `${window.location.origin}/reserva?${params.toString()}`;
    const shareData = {
      title: vehicle.name,
      text: `Mirá este vehículo: ${vehicle.name} - ${vehicle.category}`,
      url: shareUrl
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
        analytics.trackEvent('vehicle_shared', { vehicleId: vehicle.id, method: 'native' });
      } else {
        // Fallback: copiar al portapapeles
        await navigator.clipboard.writeText(shareUrl);
        toast.success('¡Link copiado al portapapeles!');
        analytics.trackEvent('vehicle_shared', { vehicleId: vehicle.id, method: 'clipboard' });
      }
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error sharing:', error);
      }
    }
  };

  return (
    <div className="vehicle-card">
      <div className="vehicle-image">
        <img src={vehicle.image || '/placeholder-car.svg'} alt={vehicle.name} />
      </div>

      <div className="vehicle-info">
        <div className="vehicle-header">
          <h3 className="vehicle-name">{vehicle.name}</h3>
          <button className="share-btn" onClick={handleShare} title="Compartir">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="18" cy="5" r="3"></circle>
              <circle cx="6" cy="12" r="3"></circle>
              <circle cx="18" cy="19" r="3"></circle>
              <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
              <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
            </svg>
          </button>
        </div>
        <p className="vehicle-category">{vehicle.category}</p>

        <VehicleFeatures features={vehicle.features} />

        {vehicle.priceWarning && (
          <InfoBadge message={vehicle.priceWarning} />
        )}

        {vehicle.warranty && (
          <InfoBadge 
            message={vehicle.warranty.message}
            link={vehicle.warranty.link}
          />
        )}
      </div>

      <div className="vehicle-actions">
        <PriceDisplay
          originalPrice={vehicle.originalPrice}
          finalPrice={vehicle.price}
          period={vehicle.period}
        />
        <button className="consult-btn" onClick={handleConsult}>
          RESERVAR
        </button>
      </div>
    </div>
  );
};

export default VehicleCard;
